module.exports = __webpack_public_path__ + "static/media/14UNEP16.de3959e3.jpg";